export function bobzaReducer(state = null, action) {
    switch (action.type) {
        case "LOGGED_IN_Bobza":
            return action.payload;

        case "Bobza_LOGOUT":
            return action.payload; //something like user will be nulled

        default:
            return state;
    }
}